export default __webpack_public_path__ + "static/media/img-refund.819b0093.svg";